// extracted by mini-css-extract-plugin
export default {"formTextareaBox":"index_formTextareaBox_VxSJm","formTextarea":"index_formTextarea_RpmdK","formTextareaWord":"index_formTextareaWord_2siP7","redSize":"index_redSize_NTNMn"};